import React from 'react'
import { Box, Accordion, AccordionSummary } from '@mui/material'
import { ReactComponent as ArrowIcon } from '../../assets/images/arrowIcon.svg'
import colors from '../../constants/colors'

interface IAccordionTimeline {
  children: React.ReactNode
  title: string | React.ReactNode
}

const AccordionTimeline: React.FC<IAccordionTimeline> = ({ title, children }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Accordion
        elevation={0}
        className='t-accordion-timeline'
        sx={{
          borderBottom: `2px solid ${colors.TAG_LINES_GRAY}`,
          backgroundColor: 'transparent',
        }}
      >
        <AccordionSummary
          expandIcon={<ArrowIcon fill={colors.TAG_LINES_GRAY} />}
          sx={{
            typography: 'bodyBold',
            px: 0,
            minHeight: 'unset !important',
            paddingBottom: '1.8rem',
            '.MuiAccordionSummary-content': {
              margin: '0px !important',
            },
            '.Mui-expanded': { margin: '0px !important', paddingBottom: '0px !important' },
          }}
        >
          {title}
        </AccordionSummary>
        {children}
      </Accordion>
    </Box>
  )
}

export default AccordionTimeline
